import React from 'react';
import { useWizard } from 'components/shared/Wizard';

import { Card, Col, Row, Divider, Space, Button, Typography, Form } from 'antd';
import BlockForm from './components/BlockForm';
import ApplicationSidebar from 'components/tenant_app/application_portal/application_sidebar/ApplicationSidebar';

import { getTranslatedString } from 'helpers/i18n';
import { toSentenceCase } from 'helpers/StringHelper';
import { formatBlock } from './helpers/WizardStepHelper';

const { Title } = Typography;

const StepItem = ({ step, onPageChange, onClickCancel, application, cotenant, isPreview }) => {
  const { nextStep, previousStep } = useWizard();

  const forms = {};
  step.blocks.forEach((block) => {
    const [form] = Form.useForm();
    forms[block.id] = form;
  });

  const handlePageChange = async (nextBack) => {
    const blocks = [];

    for (const block of step.blocks) {
      const form = forms[block.id];

      const formValidations = { valid: true, errors: [] };
      await form
        .validateFields()
        .then(() => {
          formValidations['valid'] = true;
          formValidations['errors'] = [];
        })
        .catch(({ errorFields }) => {
          formValidations['valid'] = !errorFields.length;
          formValidations['errors'] = errorFields.map(
            (error) => `${toSentenceCase(error.name.join(' '))} is a ${error.errors}`
          );
        });

      const newBlock = formatBlock(block, form, formValidations);
      blocks.push(newBlock);
    }

    onPageChange(step.id, blocks, true);
    if (nextBack === 'next') {
      nextStep();
    } else {
      previousStep();
    }
  };

  return (
    <Row gutter={16}>
      <Col className="gutter-row" xs={{ span: 24, order: 0 }} md={{ span: 8, order: 1 }}>
        <ApplicationSidebar applicationWizard cotenantId={cotenant.id} isPreview={isPreview} />
      </Col>

      <Col xs={24} md={0}>
        <Divider />
      </Col>

      <Col className="gutter-row" xs={{ span: 24, order: 1 }} md={{ span: 16, order: 0 }}>
        <Card>
          <Title level={4}>{step.title}</Title>
          <div dangerouslySetInnerHTML={{ __html: step.description }}></div>

          <Divider />

          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {step.blocks.map((block) => (
              <>
                <BlockForm
                  key={block.id}
                  form={forms[block.id]}
                  application={application}
                  cotenant={cotenant}
                  block={block}
                />

                <Divider />
              </>
            ))}
          </Space>

          <Space>
            <Button type="primary" onClick={() => handlePageChange('next')}>
              {getTranslatedString('next')}
            </Button>
            <Button type="default" onClick={() => handlePageChange('back')}>
              {getTranslatedString('back')}
            </Button>
            <Button type="default" onClick={onClickCancel}>
              {getTranslatedString('cancel')}
            </Button>
          </Space>
        </Card>
      </Col>
    </Row>
  );
};

export default StepItem;
